import { Box, CircularProgress } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'components/Loader/Loader.styles';

const Loader = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <CircularProgress />
    </Box>
  );
};

export default Loader;
